import React from 'react';
import PropTypes from 'prop-types';

/**
 * Badge component for web
 *
 * A small label/tag for statuses, counts, and categories
 */
const Badge = ({
  children,
  variant = 'primary',
  size = 'md',
  dot = false,
  className = '',
  ...props
}) => {
  const variantClasses = {
    primary: 'badge-primary',
    success: 'badge-success',
    warning: 'badge-warning',
    error: 'badge-error',
    neutral: 'badge-neutral',
  };

  const sizeClasses = {
    sm: 'px-2 py-0.5 text-xs',
    md: 'px-3 py-1 text-sm',
  };

  const badgeClasses = [
    'badge',
    variantClasses[variant],
    sizeClasses[size],
    className,
  ].filter(Boolean).join(' ');

  return (
    <span className={badgeClasses} {...props}>
      {dot && (
        <span
          className="inline-block w-2 h-2 rounded-full mr-1.5"
          style={{
            backgroundColor: 'currentColor',
          }}
        />
      )}
      {children}
    </span>
  );
};

Badge.propTypes = {
  children: PropTypes.node.isRequired,
  variant: PropTypes.oneOf(['primary', 'success', 'warning', 'error', 'neutral']),
  size: PropTypes.oneOf(['sm', 'md']),
  dot: PropTypes.bool,
  className: PropTypes.string,
};

export default Badge;
